var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_vm._m(0),_c('router-view')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mobile-message"},[_c('div',{staticClass:"text"},[_c('h3',[_c('i',{staticClass:"fa-solid fa-triangle-exclamation"}),_vm._v(" ALERT")]),_c('p',[_vm._v(" this app not working on mobile devices please open it from pc or laptop . thank you ")])])])
}]

export { render, staticRenderFns }